export function beforeVisitGlobalMember(usage, objectName) {
  let level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  let rememberObjectName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function beforeVisitGlobal(node, parent) {
    if (typeof objectName === "string" ? node.name === objectName : objectName.includes(node.name)) {
      const segments = [];
      for (let i = 1; i <= level; i++) {
        const memberParent = parent[parent.length - i];
        if ((memberParent === null || memberParent === void 0 ? void 0 : memberParent.node.type) === "MemberExpression" && memberParent.key === "object") {
          const memberNode = memberParent.node;
          if (!memberNode.computed && memberNode.property.type === "Identifier") {
            segments.push(rememberObjectName ? `${node.name}.${memberNode.property.name}` : memberNode.property.name);
          } else if (memberNode.computed && memberNode.property.type === "Literal" && typeof memberNode.property.value === "string") {
            segments.push(rememberObjectName ? `${node.name}.${memberNode.property.value}` : memberNode.property.value);
          } else {
            usage.hasNonStaticUsage = true;
          }
        } else {
          usage.hasNonStaticUsage = true;
        }
      }
      if (segments.length === level) {
        usage.usedProperties.add(segments.join("."));
      }
    }
  };
}
//# sourceMappingURL=beforeVisitGlobalMember.js.map